export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";